import { render, staticRenderFns } from "./TabPaneVertical.vue?vue&type=template&id=820ae2be&scoped=true"
import script from "./TabPaneVertical.vue?vue&type=script&lang=js"
export * from "./TabPaneVertical.vue?vue&type=script&lang=js"
import style0 from "./TabPaneVertical.vue?vue&type=style&index=0&id=820ae2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820ae2be",
  null
  
)

export default component.exports